var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vision-dashboard-page" }, [
    _c("div", { staticClass: "db-page-header" }, [
      _c("div", { staticClass: "db-page-header-left" }, [
        _c("img", {
          staticClass: "db-header-icon",
          attrs: { src: require("@/assets/img/camera.png") }
        }),
        _c("h2", { staticClass: "page-title-bar" }, [
          _vm._v(_vm._s(_vm.$t("Dashboard")))
        ])
      ])
    ]),
    _c(
      "div",
      { staticStyle: { display: "none" } },
      [
        _c(
          "v-tabs",
          {
            attrs: { "hide-slider": "" },
            model: {
              value: _vm.activeTab,
              callback: function($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab"
            }
          },
          _vm._l(_vm.tabs, function(tab) {
            return _c("v-tab", { key: tab, staticClass: "db-tab" }, [
              _vm._v(_vm._s(tab))
            ])
          }),
          1
        )
      ],
      1
    ),
    _vm.activeTab === 0
      ? _c("div", { staticClass: "db-content" }, [
          _c("div", { staticClass: "db-section-label" }, [
            _c("i", {
              staticClass: "mdi mdi-view-grid-outline db-section-icon"
            }),
            _vm._v(_vm._s(_vm.$t("Shelf Task")) + " ")
          ]),
          _c(
            "div",
            { staticClass: "shelf-task-grid" },
            _vm._l(_vm.shelfTasks, function(task) {
              return _c(
                "div",
                {
                  directives: [{ name: "ripple", rawName: "v-ripple" }],
                  key: task.title,
                  staticClass: "stask-card",
                  attrs: { role: "button", tabindex: "0" },
                  on: {
                    click: function($event) {
                      return _vm.handleTaskClick(task)
                    },
                    keydown: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleTaskClick(task)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar"
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.handleTaskClick(task)
                      }
                    ]
                  }
                },
                [
                  _c("div", {
                    staticClass: "stask-accent",
                    style: { background: task.accentColor }
                  }),
                  _c("div", { staticClass: "stask-body" }, [
                    _c("div", { staticClass: "stask-title" }, [
                      _vm._v(_vm._s(task.title))
                    ]),
                    _c("div", { staticClass: "stask-pct" }, [
                      _vm._v(_vm._s(task.percentage))
                    ]),
                    _c("div", { staticClass: "stask-count" }, [
                      _vm._v(_vm._s(task.count) + " "),
                      _c("span", [_vm._v("/ " + _vm._s(task.total) + " ea")])
                    ])
                  ])
                ]
              )
            }),
            0
          ),
          _c("div", { staticClass: "db-two-col-header" }, [
            _c("div", { staticClass: "db-section-label mb-0" }, [
              _c("i", {
                staticClass: "mdi mdi-layers-outline db-section-icon"
              }),
              _vm._v(_vm._s(_vm.$t("Shelf Info")) + " ")
            ]),
            _c("div", { staticClass: "db-section-label mb-0" }, [
              _c("i", { staticClass: "mdi mdi-heart-pulse db-section-icon" }),
              _vm._v(_vm._s(_vm.$t("Device Health Check")) + " ")
            ])
          ]),
          _c("div", { staticClass: "info-summary-grid" }, [
            _c("div", { staticClass: "shelf-info-card info-grid-card" }, [
              _c("div", { staticClass: "shelf-info-split" }, [
                _c("div", { staticClass: "shelf-info-left pa-4" }, [
                  _c("div", { staticClass: "ig-label" }, [_vm._v("SKUs")]),
                  _c("div", { staticClass: "ig-value" }, [
                    _vm._v(_vm._s(_vm.shelfInfo.skus || 0))
                  ])
                ]),
                _c("div", { staticClass: "shelf-info-right pa-4" }, [
                  _c("div", { staticClass: "ig-label" }, [
                    _vm._v(_vm._s(_vm.$t("Vision Coverage")))
                  ]),
                  _c("div", { staticClass: "vision-coverage-row mt-3" }, [
                    _c("div", { staticClass: "vision-coverage-item" }, [
                      _c("div", { staticClass: "ig-sublabel" }, [
                        _vm._v(_vm._s(_vm.$t("Shelf Groups")))
                      ]),
                      _c("div", { staticClass: "ig-subvalue" }, [
                        _vm._v(_vm._s(_vm.shelfInfo.shelfGroups || 0))
                      ])
                    ]),
                    _c("div", { staticClass: "vision-coverage-item" }, [
                      _c("div", { staticClass: "ig-sublabel" }, [
                        _vm._v(_vm._s(_vm.$t("Shelves")))
                      ]),
                      _c("div", { staticClass: "ig-subvalue" }, [
                        _vm._v(_vm._s(_vm.shelfInfo.shelves || 0))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _c(
              "div",
              { staticClass: "device-health-card info-grid-card pa-4" },
              [
                _c("div", { staticClass: "hc-title" }, [
                  _c("i", { staticClass: "mdi mdi-wifi hc-icon" }),
                  _vm._v(_vm._s(_vm.$t("Connectivity")))
                ]),
                _c(
                  "div",
                  { staticClass: "health-card-stats mt-3" },
                  _vm._l(_vm.connectivity, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.label,
                        staticClass: "health-stat-item",
                        class: { "no-border-right": item.label === "Bad" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "hc-badge",
                            class: "hc-badge--" + item.label.toLowerCase()
                          },
                          [_vm._v(_vm._s(item.label))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "health-number",
                            class: {
                              greenColor: item.label === "Good",
                              colorRed: item.label === "Bad"
                            }
                          },
                          [_vm._v(_vm._s(item.value || 0))]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "device-health-card info-grid-card pa-4" },
              [
                _c("div", { staticClass: "hc-title" }, [
                  _c("i", { staticClass: "mdi mdi-battery-high hc-icon" }),
                  _vm._v(_vm._s(_vm.$t("Battery")))
                ]),
                _c(
                  "div",
                  { staticClass: "health-card-stats mt-3" },
                  _vm._l(_vm.battery, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.label,
                        staticClass: "health-stat-item",
                        class: { "no-border-right": item.label === "Bad" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "hc-badge",
                            class: "hc-badge--" + item.label.toLowerCase()
                          },
                          [_vm._v(_vm._s(item.label))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "health-number",
                            class: {
                              greenColor: item.label === "Good",
                              colorRed: item.label === "Bad"
                            }
                          },
                          [_vm._v(_vm._s(item.value || 0))]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "device-health-card info-grid-card pa-4" },
              [
                _c("div", { staticClass: "hc-title" }, [
                  _c("i", { staticClass: "mdi mdi-server hc-icon" }),
                  _vm._v(_vm._s(_vm.$t("Edge Devices")))
                ]),
                _c("div", { staticClass: "edge-device-info mt-3" }, [
                  _c("div", { staticClass: "edge-row" }, [
                    _c("span", { staticClass: "edge-key" }, [_vm._v("Ver")]),
                    _c("span", { staticClass: "edge-val" }, [
                      _vm._v(_vm._s(_vm.edgeDevice.version || "N/A"))
                    ])
                  ]),
                  _c("div", { staticClass: "edge-row" }, [
                    _c("span", { staticClass: "edge-key" }, [_vm._v("Status")]),
                    _c(
                      "span",
                      {
                        staticClass: "edge-val edge-status",
                        class: {
                          "edge-status--ok": _vm.edgeDevice.status === "OK"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "mdi",
                          class:
                            _vm.edgeDevice.status === "OK"
                              ? "mdi-check-circle"
                              : "mdi-minus-circle"
                        }),
                        _vm._v(" " + _vm._s(_vm.edgeDevice.status) + " ")
                      ]
                    )
                  ])
                ])
              ]
            )
          ]),
          _c("div", { staticClass: "db-section-label mt-4" }, [
            _c("i", { staticClass: "mdi mdi-chart-line db-section-icon" }),
            _vm._v(_vm._s(_vm.$t("Operation Info")) + " ")
          ]),
          _c(
            "div",
            { staticClass: "operation-info-row" },
            _vm._l(_vm.operationInfo, function(item) {
              return _c(
                "div",
                { key: item.label, staticClass: "operation-card" },
                [
                  _c("div", { staticClass: "op-header" }, [
                    _c("span", { staticClass: "op-label" }, [
                      _vm._v(_vm._s(item.label))
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "op-trend",
                        class:
                          item.trend >= 0 ? "op-trend--up" : "op-trend--down"
                      },
                      [
                        _c("i", {
                          staticClass: "mdi",
                          class:
                            item.trend >= 0
                              ? "mdi-trending-up"
                              : "mdi-trending-down"
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              item.trend
                                ? Math.abs(item.trend).toFixed(2)
                                : "0.00"
                            ) +
                            "% "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "op-value" }, [
                    _vm._v(_vm._s(item.value))
                  ]),
                  _c("div", { staticClass: "op-avg" }, [
                    _vm._v(_vm._s(_vm.$t("Average")) + ": "),
                    _c("strong", [_vm._v(_vm._s(item.average))])
                  ])
                ]
              )
            }),
            0
          ),
          _c("div", { staticClass: "shelf-history-card mt-4" }, [
            _c("div", { staticClass: "shelf-history-header" }, [
              _c("div", { staticClass: "db-section-label mb-0" }, [
                _c("i", { staticClass: "mdi mdi-chart-bar db-section-icon" }),
                _vm._v(_vm._s(_vm.$t("Shelf History")) + " ")
              ]),
              _c("div", { staticClass: "shelf-history-controls" }, [
                _c(
                  "div",
                  { staticClass: "range-switcher" },
                  _vm._l(_vm.ranges, function(range) {
                    return _c(
                      "button",
                      {
                        key: range,
                        staticClass: "range-btn",
                        class: {
                          "range-btn--active": _vm.selectedRange === range
                        },
                        on: {
                          click: function($event) {
                            _vm.selectedRange = range
                          }
                        }
                      },
                      [_vm._v(_vm._s(range))]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "date-picker-wrapper" },
                  [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          transition: "scale-transition",
                          "offset-y": "",
                          "min-width": "290px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "form-input",
                                          attrs: {
                                            value: _vm.selectedDate,
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            readonly: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "append",
                                                fn: function() {
                                                  return [
                                                    _c("img", {
                                                      attrs: {
                                                        width: "16",
                                                        height: "16",
                                                        src: require("@/assets/img/ico-calendar.png")
                                                      }
                                                    })
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        "v-text-field",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3417548802
                        ),
                        model: {
                          value: _vm.dateMenu,
                          callback: function($$v) {
                            _vm.dateMenu = $$v
                          },
                          expression: "dateMenu"
                        }
                      },
                      [
                        _c("v-date-picker", {
                          attrs: {
                            locale:
                              _vm.languageCodes[
                                _vm.$store.getters[
                                  "dataStore/GET_CURRENT_LANGUAGE"
                                ]
                              ],
                            "no-title": ""
                          },
                          on: {
                            input: function($event) {
                              _vm.dateMenu = false
                            }
                          },
                          model: {
                            value: _vm.selectedDate,
                            callback: function($$v) {
                              _vm.selectedDate = $$v
                            },
                            expression: "selectedDate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm.shelfHistorySeries.length
              ? _c(
                  "div",
                  [
                    _c("apexchart", {
                      staticClass: "ml-n4",
                      attrs: {
                        type: "bar",
                        height: "320",
                        options: _vm.shelfHistoryOptions,
                        series: _vm.shelfHistorySeries
                      }
                    })
                  ],
                  1
                )
              : _c("div", { staticClass: "empty-chart-state" }, [
                  _c("i", {
                    staticClass: "mdi mdi-chart-bar empty-chart-icon"
                  }),
                  _c("p", { staticClass: "empty-text" }, [
                    _vm._v(_vm._s(_vm.$t("No data available")))
                  ])
                ])
          ])
        ])
      : _vm._e(),
    _vm.activeTab === 1
      ? _c("div", { staticClass: "db-content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6 col-12 pr-0" }, [
              _c("div", { staticClass: "dashboard-card" }, [
                _c("div", { staticClass: "db-section-label mb-3" }, [
                  _c("i", { staticClass: "mdi mdi-gauge db-section-icon" }),
                  _vm._v(_vm._s(_vm.$t("Score")))
                ]),
                _vm._m(0),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("apexchart", {
                        attrs: {
                          type: "donut",
                          height: "180",
                          options: _vm.scoreChartOptions,
                          series: _vm.scoreSeries
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-8" },
                    [
                      _c("v-simple-table", [
                        _c("thead", [
                          _c("tr", [
                            _c("th"),
                            _c("th"),
                            _c("th", [_vm._v(_vm._s(_vm.$t("Last Month")))])
                          ])
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.scoreTable, function(item) {
                            return _c("tr", { key: item.name }, [
                              _c("td", [
                                _c("span", {
                                  staticClass: "dot",
                                  style: { background: item.color }
                                }),
                                _vm._v(_vm._s(item.name))
                              ]),
                              _c("td", [
                                _c("strong", [_vm._v(_vm._s(item.current))])
                              ]),
                              _c("td", [_vm._v(_vm._s(item.previous))])
                            ])
                          }),
                          0
                        )
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "row mt-3 mx-0" },
                _vm._l(
                  [
                    {
                      h: _vm.sectionHeaders,
                      i: _vm.topSections,
                      t: "Top 5 OoS Section"
                    },
                    {
                      h: _vm.brandHeaders,
                      i: _vm.topBrands,
                      t: "Top 5 OoS Brand"
                    },
                    {
                      h: _vm.productHeaders,
                      i: _vm.topProducts,
                      t: "Top 5 OoS Product"
                    }
                  ],
                  function(tbl, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "col-md-4 pa-0",
                        class: { "pl-1": idx > 0 }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "dashboard-card rounded-0 pa-0" },
                          [
                            _c("h4", { staticClass: "card-title" }, [
                              _vm._v(_vm._s(_vm.$t(tbl.t)))
                            ]),
                            _c("v-data-table", {
                              staticClass: "tbl-type01",
                              attrs: {
                                headers: tbl.h,
                                items: tbl.i,
                                "hide-default-footer": "",
                                dense: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "no-data",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "px-2 no-data" },
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-alert-outline")
                                            ]),
                                            _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("No data available")
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }
                ),
                0
              )
            ]),
            _c("div", { staticClass: "col-lg-6 col-12" }, [
              _c("div", { staticClass: "dashboard-card" }, [
                _c(
                  "div",
                  { staticClass: "floor-header" },
                  [
                    _c("div", { staticClass: "db-section-label mb-0" }, [
                      _c("i", {
                        staticClass: "mdi mdi-map-outline db-section-icon"
                      }),
                      _vm._v(_vm._s(_vm.$t("Floor Map")))
                    ]),
                    _c(
                      "v-btn",
                      { attrs: { icon: "" } },
                      [_c("v-icon", [_vm._v("mdi-fullscreen")])],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "floor-toolbar" }, [
                  _vm._m(1),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center",
                      staticStyle: { gap: "8px" }
                    },
                    [
                      _c("v-select", {
                        staticStyle: { "max-width": "120px" },
                        attrs: {
                          items: _vm.floors,
                          dense: "",
                          outlined: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.selectedFloor,
                          callback: function($$v) {
                            _vm.selectedFloor = $$v
                          },
                          expression: "selectedFloor"
                        }
                      }),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "" },
                          on: { click: _vm.zoomIn }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-magnify-plus")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "" },
                          on: { click: _vm.zoomOut }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-magnify-minus")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "floor-map-container" }, [
                  _c(
                    "svg",
                    {
                      style: {
                        transform: "scale(" + _vm.zoomLevel + ")",
                        transformOrigin: "center center",
                        transition: "transform 0.2s ease"
                      },
                      attrs: {
                        viewBox: "0 0 200 200",
                        height: "100%",
                        width: "100%"
                      }
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "25",
                          y: "27",
                          width: "100",
                          height: "50",
                          fill: "#E5FFF7",
                          stroke: "#606060"
                        }
                      }),
                      _c("rect", {
                        attrs: {
                          x: "25",
                          y: "122",
                          width: "100",
                          height: "50",
                          fill: "#E5FFF7",
                          stroke: "#606060"
                        }
                      }),
                      _c("text", { attrs: { x: "27", y: "33" } }, [
                        _vm._v("A01-001")
                      ]),
                      _c("text", { attrs: { x: "27", y: "128" } }, [
                        _vm._v("A01-002")
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "score-header" }, [
      _c("span", { staticClass: "score-value" }, [_vm._v("0%")]),
      _c("span", { staticClass: "greenColor ml-2" }, [_vm._v("0%")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend-group" }, [
      _c("span", [_c("i", { staticClass: "dot oos" }), _vm._v(" OoS")]),
      _c("span", [_c("i", { staticClass: "dot ls" }), _vm._v(" LS")]),
      _c("span", [_c("i", { staticClass: "dot mis" }), _vm._v(" Mis")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }